import React, { useState } from 'react';
import { Page, Tabs } from '@shopify/polaris';
import { AppHeader } from '../components/common/AppHeader';
import { TenantsManagement } from '../components/admin/TenantsManagement';
import { UsersManagement } from '../components/admin/UsersManagement';
import { ProvisioningWizard } from '../components/admin/ProvisioningWizard';
import { AnalyticsDashboard } from '../components/admin/AnalyticsDashboard';
import { HealthDashboard } from '../components/admin/HealthDashboard';

export const AdminPage = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  const tabs = [
    {
      id: 'tenants',
      content: 'Tenants',
      panelID: 'tenants-panel'
    },
    {
      id: 'provisioning',
      content: 'Provisioning',
      panelID: 'provisioning-panel'
    },
    {
      id: 'users',
      content: 'Users',
      panelID: 'users-panel'
    },
    {
      id: 'analytics',
      content: 'Analytics',
      panelID: 'analytics-panel'
    },
    {
      id: 'health',
      content: 'Health',
      panelID: 'health-panel'
    }
  ];

  const handleTabChange = (selectedTabIndex) => {
    setSelectedTab(selectedTabIndex);
  };

  return (
    <Page>
      <AppHeader title="Cart Nexus Admin Panel" />
      <Tabs
        tabs={tabs}
        selected={selectedTab}
        onSelect={handleTabChange}
      >
        {selectedTab === 0 && <TenantsManagement />}
        {selectedTab === 1 && <ProvisioningWizard />}
        {selectedTab === 2 && <UsersManagement />}
        {selectedTab === 3 && <AnalyticsDashboard />}
        {selectedTab === 4 && <HealthDashboard />}
      </Tabs>
    </Page>
  );
};
